module.exports = __webpack_public_path__ + "img/image1.55960a61.png";